import { createConfirmation } from 'react-confirm';
import ConfirmationBox from "./ConfirmationBox";


// create confirm function
export const routeConfirm = createConfirmation(ConfirmationBox);